<template>
    <div class="partners-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div class="header-bg" style="background-image: url('https://picsum.photos/id/1049/1920/400');"></div>
            <div class="header-content">

                <p>与行业内企业保持密切合作关系，共同推动新能源行业发展</p>
            </div>
        </div>

        <!-- 合作理念 -->
        <section class="cooperation-philosophy">
            <div class="container">
                <h2>合作理念</h2>
                <div class="philosophy-content">
                    <p>四川庚源电力科技有限公司秉持"互利共赢、共同发展"的合作理念，与新能源行业内的企业建立了长期稳定的合作关系。我们通过专业的技术服务，为合作伙伴提供支持，同时也从合作伙伴那里获得相应的技术和产品支持，实现优势互补、共同发展。</p>
                    <p>我们相信，只有通过紧密合作，才能不断提升服务质量和技术水平，为客户提供更合适的解决方案，推动整个新能源行业的健康发展。</p>
                </div>
            </div>
        </section>
        <h2>合作伙伴</h2>
        <div class="partners-lists-container"> <!-- 外层容器 -->
            <!-- 合作伙伴列表 -->
            <section class="partners-list">
                <div class="container">

                    <div style="display: flex;">
                        <div class="partners-grid">
                            <div class="partner-card" v-for="partner in partners" :key="partner.id">
                                <div class="partner-logo">
                                    <img :src="partner.logoUrl || `https://picsum.photos/id/${200+partner.id}/300/200`" :alt="partner.name">
                                </div>
                                <div class="partner-info">
                                    <h3>{{ partner.name }}</h3>
                                    <div class="partner-description">
                                        <p>{{ partner.description || '与我公司保持长期稳定的合作关系，在新能源二次设备领域开展深度合作，共同为客户提供合适的产品和服务。' }}</p>
                                    </div>
                                    <div class="cooperation-area">
                                        <h4>合作领域：</h4>
                                        <ul>
                                            <li>{{ partner.proOne }}</li>
                                            <li>{{ partner.proTwo }}</li>
                                            <li>{{ partner.proThree }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 主要合作伙伴列表 -->
            <section class="main-partners-list">
                <div class="container">
                    <div style="display: flex;">
                        <div class="partners-grid">
                            <div class="partner-card" v-for="mainParner in mainPartners" :key="mainParner.id">
                                <div class="partner-logo">
                                    <img :src="mainParner.logoUrl || `https://picsum.photos/id/${200+mainParner.id}/300/200`" :alt="mainParner.name">
                                </div>
                                <div class="partner-info">
                                    <h3>{{ mainParner.name }}</h3>
                                    <div class="partner-description">
                                        <p>{{ mainParner.description || '与我公司保持长期稳定的合作关系，在新能源二次设备领域开展深度合作，共同为客户提供合适的产品和服务。' }}</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <!-- 合作咨询 -->
        <section class="cooperation-consultation">
            <div class="container">
                <h2>合作咨询</h2>
                <div class="consultation-content">
                    <p>如果您有合作意向，欢迎随时与我们联系，我们将为您提供详细的合作方案和咨询服务。</p>
                    <button @click="$router.push('/contact')" class="contact-btn">联系我们</button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { partnerApi } from '@/api'

export default {
    name: 'PartnersPage',
    data() {
        return {
            partners: [],
            mainPartners: []
        }
    },
    mounted() {
        this.getPartners()
        this.getMainPartners()
    },
    methods: {
        getMainPartners() {
            partnerApi.getMainPartners().then(res => {
                if (res != null) {
                    this.mainPartners = res.data;
                }
            }).catch(err => {
                console.error('获取发电集团失败', err)
            })
        },
        getPartners() {
            partnerApi.getAllPartners().then(res => {
                if (res != null) {
                    this.partners = res.data
                }
            }).catch(err => {
                console.error('获取合作伙伴失败:', err)
            })
        }
    }
}
</script>

<style scoped>
.page-header {
    position: relative;
    height: 400px;
    overflow: hidden;
}

.header-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    filter: brightness(0.6);
}

.header-content {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
}

.header-content h1 {
    font-size: 3rem;
    margin-bottom: 15px;
}

.header-content p {
    font-size: 1.2rem;
}

section {
    padding: 5px 0;
}

.container {
    width: 100%;
    max-width: 90%;
    margin: 0 auto;
    padding: 0 15px;
}

h2 {
    font-size: 2rem;
    color: #2c3e50;
    margin-bottom: 40px;
    text-align: center;
    position: relative;
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
    padding-bottom: 10px;
}

h2::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: #4164b2;
}

/* 合作理念样式 */
.cooperation-philosophy {
    background-color: #f9f9f9;
}

.philosophy-content {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
}

.philosophy-content p {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #555;
    margin-bottom: 20px;
}

/* 两个列表外层容器样式 */
.partners-lists-container {
    display: flex;
    gap: 0px; /* 控制两个列表之间的间距，数值越小越紧凑 */
    padding: 0 15px; /* 增加左右内边距，避免内容贴边 */
}

/* 合作伙伴列表样式 */
.partners-list,
.main-partners-list {
    width: 50%; /* 平均分配宽度 */
}

.partners-grid {
    display: flex;
    flex-direction: column;
    gap: 30px; /* 列表内部卡片间距 */
    width: 100%;
}

.partner-card {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 20px; /* 卡片内部logo和信息的间距 */
    align-items: center;
    padding: 20px;
    background-color: #f1f1e9;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.partner-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.partner-logo img {
    max-width: 100%;
    max-height: 200px;
    object-fit: contain;
}

.partner-info h3 {
    font-size: 1.8rem;
    color: #2c3e50;
    margin-bottom: 20px;
}

.partner-description p {
    font-size: 1rem;
    line-height: 1.8;
    color: #555;
    margin-bottom: 25px;
}

.cooperation-area h4 {
    font-size: 1.1rem;
    color: #2c3e50;
    margin-bottom: 10px;
}

.cooperation-area ul {
    list-style: none;
    padding: 0;
}

.cooperation-area li {
    margin-bottom: 8px;
    padding-left: 20px;
    position: relative;
    color: #555;
}

.cooperation-area li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #165DFF;
    font-weight: bold;
}

/* 合作咨询样式 */
.cooperation-consultation {
    background-color: #626f96;
    color: #fff;
    margin-top: 35px;
}

.cooperation-consultation h2 {
    color: #fff;
}

.cooperation-consultation h2::after {
    background-color: #fff;
}

.consultation-content {
    text-align: center;
    max-width: 700px;
    margin: 0 auto;
}

.consultation-content p {
    font-size: 1.2rem;
    line-height: 1.8;
    margin-bottom: 30px;
}

.contact-btn {
    padding: 12px 30px;
    background-color: #fff;
    color: #165DFF;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s;
}

.contact-btn:hover {
    background-color: #f1f1f1;
    transform: translateY(-2px);
}

/* 响应式样式 */
@media (max-width: 992px) {
    .partner-card {
        background: #e5e2e2;
        grid-template-columns: 1fr;
    }

    .partner-logo {
        max-width: 300px;
        margin: 0 auto;
    }
    .partners-grid {
        gap: 20px;
    }
    .partners-lists-container {
        flex-direction: column;
        gap: 30px;
    }
    .partners-list,
    .main-partners-list {
        width: 100%;
    }
}

@media (max-width: 768px) {
    .header-content h1 {
        font-size: 2.2rem;
    }

    h2 {
        font-size: 1.8rem;
    }

    .partner-info h3 {
        font-size: 1.5rem;
        text-align: center;
    }
}

@media (max-width: 576px) {
    .page-header {
        height: 300px;
    }

    .header-content h1 {
        font-size: 1.8rem;
    }

    .header-content p {
        font-size: 1rem;
    }

    section {
        padding: 50px 0;
    }
}
</style>
